/**
 * @generated SignedSource<<5c845a9e4e9231b5bb9729bcfb182fda>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type JobSpecializationsFields_Query$variables = {
  editable: boolean;
};
export type JobSpecializationsFields_Query$data = {
  readonly specializations?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly industry: {
          readonly rawId: number | null | undefined;
        } | null | undefined;
        readonly name: string;
        readonly rawId: number | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type JobSpecializationsFields_Query = {
  response: JobSpecializationsFields_Query$data;
  variables: JobSpecializationsFields_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "editable"
  }
],
v1 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rawId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "JobSpecializationsFields_Query",
    "selections": [
      {
        "condition": "editable",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "SpecializationConnection",
            "kind": "LinkedField",
            "name": "specializations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SpecializationEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Specialization",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Industry",
                        "kind": "LinkedField",
                        "name": "industry",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v2/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "specializations(first:100)"
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "JobSpecializationsFields_Query",
    "selections": [
      {
        "condition": "editable",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "SpecializationConnection",
            "kind": "LinkedField",
            "name": "specializations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SpecializationEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Specialization",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Industry",
                        "kind": "LinkedField",
                        "name": "industry",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "specializations(first:100)"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "dcebfc7c5cd9d047913bcf4d803249d2",
    "id": null,
    "metadata": {},
    "name": "JobSpecializationsFields_Query",
    "operationKind": "query",
    "text": "query JobSpecializationsFields_Query(\n  $editable: Boolean!\n) {\n  specializations(first: 100) @include(if: $editable) {\n    edges {\n      node {\n        industry {\n          rawId\n          id\n        }\n        rawId\n        name\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "de9f9161553cfbe9a8b0d6be2037eaeb";

export default node;
